import { Outlet } from 'react-router';

import { Container } from './Container';

// Layout route for every screen that renders inside the standard card. Routes using it only need to
// render their own content.
export function ContainerLayout(): React.ReactElement {
  return (
    <Container>
      <Outlet />
    </Container>
  );
}
